import React from "react";
import { Grid, Button } from "@mui/material";
import "../styles/Section1.css";
import Phone from "../assets/Images/Phone.png";
import DotPattern from "../assets/Images/DotPattern.png";

const Section1 = () => {
  return (
    <Grid
      container
      spacing={4}
      sx={{
        mt: 3,
        position: "relative",
        backgroundImage: `url(${DotPattern})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top right",
        backgroundSize: "contain",
      }}
    >
      <Grid item xs={12} sm={6}>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
            mt: 4,
          }}
        >
          <Grid item xs={11} sm={8}>
            <div className="heading">
              Revolutionize Your <span className="col-52">Savings</span> Journey
            </div>
            <div className="text">
              Collaborate to achieve your financial goals through trusted
              community savings.
            </div>
            <div className="">
              <Button
                variant="contained"
                sx={{ mt: 4, pt: 2, pb: 2, bgcolor: "#52057B" }}
                className="start-btn"
              >
                Start Saving Today
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid
          container
          sx={{
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <img alt="img-phone" src={Phone} className="img-phone"></img>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Section1;
